import { storeToRefs } from 'pinia'
import { RouteLocationRaw, Router } from 'vue-router'

import { QueryClient } from '@tanstack/vue-query'
import { RouteNamedMap } from 'vue-router/auto-routes'

import { onboardingDraftKeys } from './composables/useOnboardingDraft'

import { OnboardingDraft } from '../shared/api/generated/models'

import { useAuthSiteStore } from '../user/authSiteStore'

import { dashboardRoutes } from '../dashboard/routes'
import { loadDraft } from './onboarding.service'
import { emptyDraft } from './onboarding.types'
import { steps } from './stepRegistry'

export function installOnboardingGuard(
  router: Router,
  queryClient: QueryClient,
) {
  router.beforeEach(async (to) => {
    const authSiteStore = useAuthSiteStore()
    const { currentSite } = storeToRefs(authSiteStore)

    const needsOnboardingRecord =
      to.meta.onboardingEntry || to.name === '/(app)/[org]/onboarding/[stepId]'
    if (needsOnboardingRecord) {
      // const queryClient = useQueryClient()
      const record = await queryClient.ensureQueryData({
        queryKey: onboardingDraftKeys.all,
        queryFn: async () =>
          (await loadDraft(currentSite.value!.id)) ?? {
            revision: 0,
            draft: emptyDraft(),
            completed_at: null as string | null,
          },
      })
      //   const record = await loadDraft(site.id)
      const resume = resolveResumeStep(record)
      if (to.meta.onboardingEntry) {
        return resume
          ? toNamedRoute('/(app)/[org]/onboarding/[stepId]', {
              org: currentSite.value!.slug,
              stepId: resume,
            })
          : dashboardRoutes.dashboard(currentSite.value!.slug)
      }
    }
  })
}

export function resolveResumeStep(
  onboardingDraft: OnboardingDraft,
): string | null {
  if (onboardingDraft.completed_at) return null
  const draft = onboardingDraft.draft

  const next = steps.find(
    (s) => !s.isComplete(draft) && !draft.skippedStepIds.includes(s.id),
  )
  if (next) return next.id

  return steps.at(-1)!.id
}

function toNamedRoute<T extends keyof RouteNamedMap>(
  name: T,
  params?: RouteNamedMap[T]['params'],
): RouteLocationRaw {
  return { name, params } as RouteLocationRaw
}
